import { george, observer, pr, React, theme, ui, config } from "aaa";
import { getProductUrl, IStorePlugin, IStoreProduct, replaceAdditionalParams } from "./StoreStore";
import { RefObject, ReactElement } from "react";
import externalInterfaceStore from "stores/ExternalInterfaceStore";

export const STORE_BORDER_RADIUS = 6;

type IProps = {
    isLoading?: boolean,
    item?: IStoreProduct | IStorePlugin,
    marginRight?: number,
    width?: number | string,
    forceRender?: boolean, // for debugging purposes, render without offer
    onClick?: () => void,
};

export const ProductThumbnailBig = observer(React.forwardRef<HTMLAnchorElement, IProps>((props, ref) => {
    // Not loading anymore, but no product or plugin
    if (!props.isLoading
        && !props.item
    ) {
        return null;
    }

    let url;
    let text;
    let name;

    const image = props.item?.imageBig ? `url(${config.network.imageBaseUrl}${props.item.imageBig})` : "";

    if (props.item?.type === "PRODUCT") {
        const product = props.item as IStoreProduct;
        const title = product.title; // product.titleId ? ui.__(product.titleId) : null;
        url = getProductUrl(product);

        if (url && product.openInExternalBrowser && externalInterfaceStore.isGeorgeApp) {
            url = `georgeapp://at/open_external_link?url=${encodeURIComponent(url)}`;
        }

        text = product.text; // ui.__(product.textId);
        name = {
            __html: product.offer ?
                (title || product.offer.marketingName || product.offer.productName) :
                ("DEBUG: " + product.channelProduct)
        };
    } else if (props.item?.type === "PLUGIN") {

        const plugin = props.item as IStorePlugin;
        name = {
            __html: plugin.name
        };
        text = plugin.text;
        url = replaceAdditionalParams(plugin.url, { productCode: props.item.productCode });
    }

    return (
        <a
            href={props.isLoading ? undefined : url}
            target="_blank"
            style={{
                textDecoration: "none",
                height: 379,
                width: props.width ? props.width : "100%",
                maxWidth: ui.TABLET_LANDSCAPE_WIDTH,
                marginRight: props.marginRight
            }}
            ref={ref}
            role="button"
            aria-label={props.isLoading ? ui.__("a11y.loading") : `${name?.__html}. ${text}.`}
            onClick={props.onClick}
        >
            <div
                className="theme-paper-color"
                style={{
                    borderRadius: STORE_BORDER_RADIUS,
                    height: 379,
                    width: props.width ? props.width : "100%",
                    boxShadow: "0px 0px 20px rgba(0,0,0,0.10)",
                    overflow: "hidden",
                    cursor: "pointer",
                    display: "flex",
                    flexDirection: "column"
                }}
            >
                <george.StoreLoadingIndicator isLoading={props.isLoading} height="100%" />
                {!props.isLoading && props.item &&
                    <>
                        <div
                            style={{
                                backgroundImage: image,
                                backgroundSize: "cover",
                                backgroundPosition: "center center",
                                padding: theme.MARGIN,
                                flex: 1
                            }}
                        >
                            {/* In case we need the white text again, like in mockups
                        <pr.P_SEMI_22 style={{ color: props.product.textColor || "white" }}>{ui.__(props.product.textId)}</pr.P_SEMI_22> 
                        */}
                        </div>
                        <div style={{ padding: theme.MARGIN, minHeight: 80 }}>
                            <pr.P_SEMI_18
                                className="theme-title-color"
                                style={{ hyphens: "auto", marginBottom: theme.MARGIN_SMALL }}
                                dangerouslySetInnerHTML={name}
                            />
                            <pr.P_14_CONTENT>{text}</pr.P_14_CONTENT>
                        </div>
                    </>
                }

            </div>
        </a>
    );
}));



// WEBPACK FOOTER //
// ./src/components/store/ProductThumbnailBig.tsx